module.exports = __webpack_public_path__ + "img/fangan02.14bcc694.png";